import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const serviceDepartmentDetailsTodo = createAsyncThunk("serviceDepartmentDetails", async (data) => {
    try {
        const res = await axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL + `service_department/${data.id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getSession('user_token') }
        })
        return res
    }
    catch (error) {
        return error.response
    }
})

const serviceDepartmentDetailsSlice = createSlice({
    name: 'serviceDepartmentDetails',
    initialState: {
        data: [],
        isLoading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(serviceDepartmentDetailsTodo.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action?.payload?.data?.data
                state.isLoading = false
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action.payload.data.message, action.meta.arg.navigate)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.isLoading = false
            }
        });
        builder.addCase(serviceDepartmentDetailsTodo.pending, (state, action) => {
            state.isLoading = true
        })
        builder.addCase(serviceDepartmentDetailsTodo.rejected, (state, action) => {
            // console.log("reject", action)
        })
    }
})

export default serviceDepartmentDetailsSlice.reducer;
